/**
 * Opens whichever chat is live: the FNP chat client when the CleverTap flag
 * `showFNPChatForWeb` is on (useABTestingView mirrors it onto window), else Freshchat.
 * @param {{ subOrderId?: string }} [options] the sub-order being asked about (order pages)
 */
export const openSiteChat = ({ subOrderId } = {}) => {
  if (window.showFNPChatForWeb) {
    // widget.js reads window.FnpChatUser on every open (it overrides an earlier setUser), so the sub-order goes there
    if (subOrderId && window.FnpChatUser) window.FnpChatUser = { ...window.FnpChatUser, subOrderId };
    window.FnpChat?.("open");
    return;
  }
  if (window.fcWidget) {
    window.fcWidget.open();
    window.fcWidget.show();
  }
};
